import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';
import { useEffect, useState } from 'react';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    marginBottom: 0,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black',
    padding: 10
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 0,
    padding: 5,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black'
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5,
    minHeight: '100px'
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '12.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    backgroundColor: 'navy',
    color: 'white'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    backgroundColor: 'navy',
    color: 'white'
  },
  headerText: {
    fontSize: 8,
    fontWeight: 'bold',
    marginLeft: 25,
    marginRight: 25
  },
  columnHeader: {
    width: 'auto'
  },
  columnText: {
    width: '10%',
    textAlign: 'center'
  },
  columnTextWide: {
    width: '17%',
    textAlign: 'center'
  },
  columnTextNarrow: {
    width: '5%',
    textAlign: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const DischargeSummaryPDF = ({ data }) => {
  console.log(data);
  const medicines = data?.medicines || [];
  const user = JSON.parse(localStorage.getItem('user'));
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`Discharge Summary`}>
          <Page size="A4" style={styles.page}>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text content="Discharge Summary" style={{ fontSize: '12px', margin: '0 auto' }} />
            </View>
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Patient Name       :     " style={styles.textBold} />
                  <Text content={`${data.name || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Address               :    " style={styles.textBold} />
                  <Text content={`${data.address || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="UHID No.             :     " />
                  <Text content={`${data.uhid || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Mob No.               :     " />
                  <Text content={`${data.mobile || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Admission Date   :    " />
                  <Text content={`${formatDate(data.date) || ''} ${data.time || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Room No.            :      " />
                  <Text content={`${data.room_no || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Consultant           :     " />
                  <Text content={`${data.consultant || ''}`} />
                </View>
              </View>
              <View style={styles.column}></View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Age/Sex               :      " />
                  <Text content={`${data.age || ''} / ${data.gender || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="IPD No.                 :     " />
                  <Text content={`${data.ipd_no || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Discharge Date    :      " />
                  <Text content={`${formatDate(data.dis_date) || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Ward                    :       " />
                  <Text content={`${data.ward_name || ''}`} />
                </View>
                {/* <View style={styles.row}>
                  <Text content="Category              :    " />
                </View> */}
                <View style={styles.row}>
                  <Text content="Department          :         " />
                  <Text content={`${data.department || ''}`} />
                </View>
              </View>
            </View>
            {data.diagnos && data.diagnos.length > 0 ? (
              data.diagnos.map((item, index) => (
                <View style={styles.contentContainer2}>
                  <View style={styles.column}>
                    <View style={styles.row}>
                      <Text content="Add Diagnos                        :      " style={styles.textBold} />
                      <Text content={`${item.add_diagnos || ''}`} />
                    </View>
                  </View>
                </View>
              ))
            ) : (
              <View style={{ ...styles.row, padding: '5px' }}>
                <Text style={{ ...styles.columnText, width: '100%' }}>No diagnosis available</Text>
              </View>
            )}

            {data.other_details.final_diagnosis && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Final Diagnosis                    :      " style={styles.textBold} />
                    <Text content={`${data?.other_details?.final_diagnosis || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.other_details.chief_complaints && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Chief Complaints                 :      " style={styles.textBold} />
                    <Text content={`${data?.other_details?.chief_complaints || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.other_details.past_history && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Past History                         :      " style={styles.textBold} />
                    <Text content={`${data?.other_details?.past_history || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.other_details.history && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="History                                 :       " style={styles.textBold} />
                    <Text content={`${data?.other_details?.history || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.other_details.personal_history && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Personal History                  :     " style={styles.textBold} />
                    <Text content={`${data?.other_details?.personal_history || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.other_details.other_investigation && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Other Investigation              :      " style={styles.textBold} />
                    <Text content={`${data?.other_details?.other_investigation || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.other_details.surgery_detail && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Surgery Details                   :       " style={styles.textBold} />
                    <Text content={`${data?.other_details?.surgery_detail || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.other_details.course_in_hospital && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Course In Hospital              :      " style={styles.textBold} />
                    <Text content={`${data?.other_details?.course_in_hospital || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.other_details.condition_at_discharge && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Condition At Discharge       :      " style={styles.textBold} />
                    <Text content={`${data?.other_details?.condition_at_discharge || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.other_details.medicine && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Medicine                             :      " style={styles.textBold} />
                    <Text content={`${data?.other_details?.medicine || ''}`} />
                  </View>
                </View>
              </View>
            )}

            <View style={{ ...styles.contentContainer2, height: '130px', flexDirection: 'row' }}>
              <View style={{ backgroundColor: 'blue' }}>
                <Text content="Clinical Examinations" style={{ width: '100%', textAlign: 'center' }} />
              </View>
              {/* First Column */}
              <View style={{ ...styles.column, marginTop: '5%', marginLeft: '30px' }}>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Consiousness Level: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.consiouness_level || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Abdomen: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.abdomen || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Blood Pressure(Systolic): " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.blood_pressure_systolic || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Blood Pressure(Diastolic): " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.blood_pressure_diastolic || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Pluse: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.pulse || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Chest: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.chest || ''}`} />
                </View>
              </View>

              {/* Second Column */}
              <View style={{ ...styles.column, marginLeft: '20px', marginTop: '5%' }}>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="CNS: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.cns || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="CVS: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.cvs || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Temperature: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.temprature || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Respiratory Rate: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.respiratory_rate || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Local Examination: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.local_examination || ''}`} />
                </View>
                <View style={{ ...styles.row, alignItems: 'center' }}>
                  <Text content="Any Other: " style={styles.textBold} />
                  <Text content={`${data?.clinical_examination?.any_other || ''}`} />
                </View>
              </View>
            </View>
            {data.lab.lab_investigation && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Lab                             :      " style={styles.textBold} />
                    <Text content={`${data?.lab?.lab_investigation || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.radiology.radiology && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Radiology                  :      " style={styles.textBold} />
                    <Text content={`${data?.radiology?.radiology || ''}`} />
                  </View>
                </View>
              </View>
            )}

            {/* Table */}
            <View style={styles.headerContainer}>
              <Text content="S. No." style={styles.columnTextNarrow} />
              <Text content="Discharge Medicine" style={{ ...styles.columnText, width: '20%' }} />
              <Text content="Frequency" style={styles.columnTextWide} />
              <Text content="Morning" style={styles.columnText} />
              <Text content="Noon" style={styles.columnText} />
              <Text content="Evening" style={styles.columnText} />
              <Text content="Night" style={styles.columnText} />
              <Text content="Days" style={styles.columnText} />
            </View>
            {data.medicine && data.medicine.length > 0 ? (
              data.medicine.map((item, index) => (
                <View
                  style={{
                    ...styles.row,
                    backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                    marginTop: 5,
                    padding: '5px'
                  }}
                  key={index}
                >
                  <Text content={index + 1} style={{ ...styles.columnTextNarrow }} />
                  <Text content={item.name || '-'} style={{ ...styles.columnText, width: '20%' }} />
                  <Text content={item.frequency_id?.frequency || '-'} style={{ ...styles.columnText, width: '22%' }} />
                  <Text content={item.morning === 'true' ? 'YES' : '' || ''} style={styles.columnText} />
                  <Text content={item.noon === 'true' ? 'YES' : '' || ''} style={styles.columnText} />
                  <Text content={item.evening === 'true' ? 'YES' : '' || ''} style={{ ...styles.columnText }} />
                  <Text content={item.night === 'true' ? 'YES' : '' || ''} style={{ ...styles.columnText }} />
                  <Text content={item.days || '0'} style={{ ...styles.columnText }} />
                </View>
              ))
            ) : (
              <View style={{ ...styles.row }}>
                <Text content="No receipts found" style={styles.columnTextNarrow} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={styles.columnTextWide} />
                <Text content="-" style={styles.columnText} />
                <Text content="0" style={{ ...styles.columnText, width: '20%' }} />
              </View>
            )}
            {data.advice_on_discharge.doctor_advice && (
              <View style={{ ...styles.contentContainer2, marginTop: '10%' }}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Doctor Advise                  :         " style={styles.textBold} />
                    <Text content={`${data?.advice_on_discharge?.doctor_advice || ''}`} />
                  </View>
                </View>
              </View>
            )}
            {data.advice_on_discharge.emergency_contact_details && (
              <View style={styles.contentContainer2}>
                <View style={styles.column}>
                  <View style={styles.row}>
                    <Text content="Emergency Contact Details           :      " style={styles.textBold} />
                    <Text content={`${data?.advice_on_discharge?.emergency_contact_details || ''}`} />
                  </View>
                </View>
              </View>
            )}
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Prepared By             :     " style={styles.textBold} />
                  <Text content={`${user.name || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Next Follow Time      :        " />
                  <Text content={`${data?.next_follow_up || ''} Days`} />
                </View>
              </View>
              <View style={styles.column}></View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="(Doctor Name)                    :   " />
                  <Text content={`${data?.consultant || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Consultant Doctor & Sign   :" />
                </View>
              </View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
